<div
  *ngIf="checkboxForm"
  class="checkbox-search"
  [class.modal]="!!modalOpen"
  [formGroup]="checkboxForm"
  [class.checkbox-search--checked]="!!value"
  tabindex="0"
  role="checkbox"
  [attr.aria-checked]="!!value"
  (keydown.space)="selectValue($event)"
  (click)="selectValue()"
>
  {{ field.placeholder }}
</div>
